<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'BuildUserStat',
  props: {
    title: {
      type: String,
      default: '赠送人数'
    },
    k: {
      type: String,
      default: 'user'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        color: ['#00BFFF', '#FF69B4'],
        title: {
          text: this.title
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['赠送数量', '赠送人数', '人均赠送'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '赠送人数',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            },
            itemStyle: {
              // 设置柱子宽度
              barWidth: '50%'
            }
          }
        ]
      }
    },
    refresh(data) {
      const time = []
      const stat = []
      for (const i in data) {
        time.push(dateStrTodate(data[i].date))
        stat.push(data[i][this.k])
      }
      this.option.xAxis.data = time
      this.option.series[0].data = stat
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
